<template>
  <div class="ant-list-item remove-padding">
    <a-row type="flex" class="list-row" :gutter="24">
      <a-col
        v-for="(header, i) in headers"
        class="sorter-wrapper"
        :key="i"
        :span="colSpans[i]"
      >
        <div class="sorter" role="button" @click="sort(header)">
          <h4 class="ant-list-item-meta-title">{{ header.title }}</h4>
          <span v-if="header.sort" class="sorter-icon">
            <a-icon type="caret-up" :class="{ on: orderBy === header.key }" />
            <a-icon
              type="caret-down"
              :class="{ on: orderBy === `-${header.key}` }"
            />
          </span>
        </div>
      </a-col>
    </a-row>
    <ul class="ant-list-item-action" v-if="actionsCols > 0">
      <li v-for="index in actionsCols" :key="index">
        <span class="action-placeholder" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    actionsCols: {
      type: Number,
      default: 0
    },
    colSpans: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      orderBy: null
    }
  },
  methods: {
    sort(header) {
      if (!header.sort) return

      this.orderBy =
        header.key === this.orderBy
          ? `-${header.key}`
          : !this.orderBy
          ? header.key
          : null

      this.$emit('sort', this.orderBy)
    }
  }
}
</script>

<style lang="scss" scoped>
.action-placeholder {
  display: block;
  width: 40px;
  height: 0;
}

.remove-padding {
  padding: 0;
}

.list-row {
  flex: 1;
  width: 100%;
}

.sorter-wrapper {
  display: flex;
}

.sorter {
  display: flex;
  cursor: pointer;

  .ant-list-item-meta-title {
    color: rgba(black, 0.65);
  }
}

.sorter-icon {
  display: flex;
  flex-direction: column;
  margin-left: 8px;

  cursor: pointer;
  transform: scale(0.916667);

  .anticon {
    position: relative;
    color: #bfbfbf;
    font-size: 12px;
    transition: color 0.2s;

    &:first-child {
      top: 2px;
    }

    &:last-child {
      top: -2px;
    }

    &.on {
      color: #0b0204;
    }
  }
}
</style>
